import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import { superCall as _$su, extend as _$ex, EMPTY_OBJ as _$em, createUnknownComponentVNode as _$cc, className as _$cn } from 'intact-vue-next';
import { DropdownMenu } from '../dropdown';
import { Tree } from '../tree';
import { makeStyles } from './styles';
export default function ($props, $blocks, $__proto__) {
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _this$get = this.get(),
    data = _this$get.data,
    uncorrelated = _this$get.uncorrelated,
    load = _this$get.load,
    showLine = _this$get.showLine,
    defaultExpandAll = _this$get.defaultExpandAll,
    checkbox = _this$get.checkbox,
    multiple = _this$get.multiple,
    filterable = _this$get.filterable;
  var _this$value = this.value,
    selectedKeys = _this$value.selectedKeys,
    checkedKeys = _this$value.checkedKeys,
    treeRef = _this$value.treeRef,
    onChangeCheckedKeys = _this$value.onChangeCheckedKeys,
    onChangeSelectedKeys = _this$value.onChangeSelectedKeys;
  var k = this.config.k;
  return _$su.call($this, null, function ($blocks) {
    var _$blocks = {},
      __$blocks = _$ex({}, $blocks);
    return (_$blocks['base-menu'] = function ($super) {
      var _$cn2;
      return _$cc(DropdownMenu, {
        'className': _$cn((_$cn2 = {}, _$cn2[k + "-tree-select-menu"] = true, _$cn2[makeStyles(k)] = true, _$cn2)),
        'children': _$cc(Tree, {
          'ref': treeRef,
          'data': data,
          'selectedKeys': selectedKeys.value,
          'ev-$change:selectedKeys': onChangeSelectedKeys,
          'checkedKeys': checkedKeys.value,
          'ev-$change:checkedKeys': onChangeCheckedKeys,
          'defaultExpandAll': defaultExpandAll,
          'uncorrelated': uncorrelated,
          'checkbox': checkbox,
          'multiple': multiple,
          'selectable': !checkbox,
          'load': load,
          'showLine': showLine,
          'filter': filterable ? _filterInstanceProperty(this) : null,
          'ev-transitionEnd': this.position
        }, null, treeRef)
      });
    }, __$blocks['base-menu'] = function ($super, data) {
      var block = $blocks['base-menu'];
      var callBlock = function callBlock() {
        return _$blocks['base-menu'].call($this, $super, data);
      };
      return block ? block.call($this, callBlock, data) : callBlock();
    }), __$blocks;
  }.call($this, $blocks), $__proto__);
}
;